import { Box } from '@wix/design-system';
import React, { useState } from 'react';
import { useIsMobile, useValidChildren } from '../../hooks';
import { SelectableProductCard, } from './SelectableProductCard';
import { SelectableWrapper } from './SelectableWrapper';
import { SelectedIcon } from './SelectedIcon';
export const SelectableProductCardList = ({ preselectedIndex, children, gap, }) => {
    const isMobile = useIsMobile();
    const [selected, setSelected] = useState(preselectedIndex);
    React.useEffect(() => {
        setSelected(preselectedIndex);
    }, [preselectedIndex]);
    const validCards = useValidChildren(children, [SelectableWrapper, SelectableProductCard], () => `SelectableProductCardList only accepts SelectableProductCardList.Card as children. Got invalid child:`);
    return (React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', gap: gap && `${gap}px`, align: "center" }, React.Children.toArray(validCards).map((child, index) => {
        const handleSelect = () => {
            setSelected(index);
            child.props.onSelect?.();
        };
        const modifiedCard = React.cloneElement(child, {
            onSelect: handleSelect,
            isSelected: selected === index,
        });
        return modifiedCard;
    })));
};
SelectableProductCardList.Card = SelectableProductCard;
SelectableProductCardList.Wrapper = SelectableWrapper;
SelectableProductCardList.SelectedIcon = SelectedIcon;
//# sourceMappingURL=SelectableProductCardList.js.map